/**
 * Fire a GA4 event through the global gtag (loaded once in index.html, gated by
 * Consent Mode v2). The event is recorded only when the visitor has granted
 * analytics consent; before that GA models/drops it — so no extra consent check
 * is needed here. No-op when gtag is absent (SSR/prerender, ad-blockers, or
 * analytics not yet loaded). Use GA4 recommended event names (e.g. generate_lead).
 */
export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params ?? {});
}
